import vEmbed from "./v-embed.vue";

export default Vue => {
  Vue.component("v-embed", vEmbed);
};
